import AmexShopSmallTerms from './AmexShopSmallTerms';

export default AmexShopSmallTerms;
